import { CheckGroupType } from '../model/types';

const renderStatusLabels = (group: CheckGroupType) => {
  return (
    <div className="d-flex align-items-center gap-4 gap-md-8">
      {group.statusCount.ok > 0 && (
        <div className="d-flex align-items-center">
          <span className="fw-bold">OK</span>
          <span className="badge  badge-success ms-2">{group.statusCount.ok}</span>
        </div>
      )}

      {group.statusCount.warning > 0 && (
        <div className="d-flex align-items-center">
          <span className="fw-bold">Warning</span>
          <span className="badge  badge-warning ms-2">{group.statusCount.warning}</span>
        </div>
      )}

      {group.statusCount.notOk > 0 && (
        <div className="d-flex align-items-center">
          <span className="fw-bold">Not OK</span>
          <span className="badge  badge-danger ms-2">{group.statusCount.notOk}</span>
        </div>
      )}
    </div>
  );
};

interface ExpandBtnProps {
  isExpanded: boolean;
  label?: string;
  group: CheckGroupType;
  toggleSection: () => void;
}

const ExpandBtn = ({ isExpanded, label, group, toggleSection }: ExpandBtnProps) => {
  return (
    <div
      className="bg-light-secondary p-3 d-md-flex d-block align-items-center cursor-pointer gap-10 border-bottom border-light"
      onClick={() => toggleSection()}
      style={{ cursor: 'pointer' }}
    >
      <div className="d-flex align-items-center gap-3 mb-2 mb-md-0">
        <div>
          <i
            className={
              isExpanded
                ? 'las la-chevron-circle-up fs-2x text-secondary'
                : 'text-secondary las la-chevron-circle-down fs-2x'
            }
          ></i>
        </div>
        <span className="fs-5 fw-bold text-black">{label}</span>
      </div>
      <div className="ps-10 ps-md-0 ">{renderStatusLabels(group)}</div>
    </div>
  );
};

export default ExpandBtn;
